import PropTypes from 'prop-types';
 
// This is a simple checkbox component designed for use in forms.
// Additional content, such as links, can be included within the checkbox label by passing them as children to this component.
function Checkbox({ label, name, value, className='checkbox-container', onChange, checked='ignore', required, children}) {

  return (
    <div className={className}>
      {checked === 'ignore' ? 
      ( <input type="checkbox" name={name} id={name} value={value} onChange={onChange} /> ) : 
      ( <input type="checkbox" name={name} id={name} value={value} onChange={onChange} checked={checked} required={required} />
      )}
      <label className="checkbox-label" htmlFor={name}>
        {label}
        {children}
      </label>
    </div>
  );  
}

Checkbox.propTypes = {
  label:     PropTypes.string,
  name:      PropTypes.string,
  value:     PropTypes.bool,
  className: PropTypes.string,
  onChange:  PropTypes.func,
  checked:   PropTypes.bool,
  required:  PropTypes.bool,
  children:  PropTypes.node
};

export default Checkbox;

// Example Usage:

//<Checkbox label="I agree to the terms and conditions">
//  <a href="/terms">View terms</a>
//</Checkbox>
